//#region  Old code

// export class PropertyHistoryModel {
//     PROPERTY_ID;
//     STATUS;
//     LISTING_AGENT_1;
//     LISTING_AGENT_4;
//     LISTING_AGENT_FIRM;
//     PRICE;
//     CAP_RATE;
//     NET_OPERATING_INCOME;
//     PRICE_PER_SQFT;
//     RENT_PER_SQFT;
//     BASE_RENT;
//     VACANCY;
//     BUYER_ID;
//     SELLER_ID;

//     constructor(data) {
//         this.PROPERTY_ID = data.ARCIMEDES_ROW_ID;
//         this.STATUS = data.STATUS;
//         this.LISTING_AGENT_1 = data.LISTING_AGENT_1;
//         this.LISTING_AGENT_4 = data.LISTING_AGENT_4;
//         this.LISTING_AGENT_FIRM = data.LISTING_AGENT_4_FIRM;
//         this.BUYER_ID = data.BUYER_ID;
//         this.SELLER_ID = data.SELLER_ID;
//         this.RENT_PER_SQFT = data.RENT_PER_SQFT;
//         this.BASE_RENT = data.BASE_RENT;
//         this.VACANCY = data.VACANCY;

//         switch (data.STATUS) {
//             case 'Active':
//             case 'Flagged':
//                 this.DATE = data.SOURCE === 'STRIVE' ? data.LISTED_DATE : data.LAST_MODIFIED_DATE;
//                 this.PRICE = data.LIST_PRICE;
//                 this.CAP_RATE = data.CAPITALIZATION_RATE;
//                 this.NET_OPERATING_INCOME = data.NET_OPERATING_INCOME;
//                 this.PRICE_PER_SQFT = data.PRICE_PER_SQFT;
//                 break;
//             case 'Closed':
//                 this.DATE = data.CLOSE_OF_ESCROW;
//                 this.PRICE = data.SOLD_PRICE;
//                 this.CAP_RATE = data.CLOSE_CAP_RATE;
//                 this.NET_OPERATING_INCOME = data.CLOSE_NOI;
//                 this.PRICE_PER_SQFT = data.CLOSE_PRICE_PER_SQFT;
//                 break;
//             case 'Removed':
//                 this.DATE = data.LAST_MODIFIED_DATE;
//                 this.PRICE = data.LIST_PRICE;
//                 this.CAP_RATE = data.CAPITALIZATION_RATE;
//                 this.NET_OPERATING_INCOME = data.NET_OPERATING_INCOME;
//                 this.PRICE_PER_SQFT = data.PRICE_PER_SQFT;
//                 break;
//         }
//     }
// }


// export class CurrentHistoryModel extends PropertyHistoryModel {
//     LISTING_AGENT_1_FIRST_NAME;
//     LISTING_AGENT_1_LAST_NAME;
//     LISTING_AGENT_4_FIRST_NAME;
//     LISTING_AGENT_4_LAST_NAME;
//     LISTING_AGENT_FIRM_NAME;
//     BUYER_FIRST_NAME;
//     BUYER_LAST_NAME;
//     SELLER_FIRST_NAME;
//     SELLER_LAST_NAME;

//     constructor(data) {
//         super(data);
//         this.LISTING_AGENT_1_FIRST_NAME = data.LISTING_AGENT_1_FIRST_NAME;
//         this.LISTING_AGENT_1_LAST_NAME = data.LISTING_AGENT_1_LAST_NAME;
//         this.LISTING_AGENT_4_FIRST_NAME = data.LISTING_AGENT_4_FIRST_NAME;
//         this.LISTING_AGENT_4_LAST_NAME = data.LISTING_AGENT_4_LAST_NAME;
//         this.LISTING_AGENT_FIRM_NAME = data.LISTING_AGENT_FIRM_NAME;
//         this.BUYER_FIRST_NAME = data.BUYER_FIRST_NAME;
//         this.BUYER_LAST_NAME = data.BUYER_LAST_NAME;
//         this.SELLER_FIRST_NAME = data.SELLER_FIRST_NAME;
//         this.SELLER_LAST_NAME = data.SELLER_LAST_NAME;
//     }
// }

//#endregion

export class PropertyHistoryModel {
    property_id;
    status;
    listing_agent_1;
    listing_agent_4;
    listing_agent_firm;
    price;
    cap_rate;
    net_operating_income;
    price_per_sqft;
    rent_per_sqft;
    base_rent;
    vacancy;
    buyer_id;
    seller_id;


    constructor(data) {
        this.property_id = data.arcimedes_row_id;
        this.status = data.status;
        this.listing_agent_1 = data.listing_agent_1;
        this.listing_agent_4 = data.listing_agent_4;
        this.listing_agent_firm = data.listing_agent_4_firm;
        this.buyer_id = data.buyer_id;
        this.seller_id = data.seller_id;
        this.rent_per_sqft = data.rent_per_sqft;
        this.base_rent = data.base_rent;
        this.vacancy = data.vacancy;

        switch (data.status) {
            case 'Active':
            case 'Flagged':
                this.date = data.source === 'STRIVE' ? data.listed_date : data.last_modified_date;
                this.price = data.list_price;
                this.cap_rate = data.capitalization_rate;
                this.net_operating_income = data.net_operating_income;
                this.price_per_sqft = data.price_per_sqft;
                break;
            case 'Closed':
                this.date = data.close_of_escrow;
                this.price = data.sold_price;
                this.cap_rate = data.close_cap_rate;
                this.net_operating_income = data.close_noi;
                this.price_per_sqft = data.close_price_per_sqft;
                break;
            case 'Removed':
                this.date = data.last_modified_date;
                this.price = data.list_price;
                this.cap_rate = data.capitalization_rate;
                this.net_operating_income = data.net_operating_income;
                this.price_per_sqft = data.price_per_sqft;
                break;
            case 'Proposal':
            case 'Property Info':    
                this.date = data.last_modified_date;
                break;    
        }
    }
}


export class CurrentHistoryModel extends PropertyHistoryModel {

    listing_agent_1_first_name;
    listing_agent_1_last_name;
    listing_agent_4_first_name;
    listing_agent_4_last_name;
    listing_agent_firm_name;
    buyer_first_name;
    buyer_last_name;
    seller_first_name;
    seller_last_name;


    constructor(data) {
        super(data);
        this.ownership_period = 'Current';
        this.is_current_ownership = true;
        this.listing_agent_1_first_name = data.listing_agent_1_first_name;
        this.listing_agent_1_last_name = data.listing_agent_1_last_name;
        this.listing_agent_4_first_name = data.listing_agent_4_first_name;
        this.listing_agent_4_last_name = data.listing_agent_4_last_name;
        this.listing_agent_firm_name = data.listing_agent_firm_name;
        this.buyer_first_name = data.buyer_first_name;
        this.buyer_last_name = data.buyer_last_name;
        this.seller_first_name = data.seller_first_name;
        this.seller_last_name = data.seller_last_name;
    }
}